import {Howl, Howler} from 'howler';

// Cache references to DOM elements.
/*var elms = ['track', 'timer', 'duration', 'playBtn', 'pauseBtn', 'progress', 'preloadProgress', 'progressBar'];
elms.forEach(function(elm) {
	window[elm] = document.getElementById(elm);
});*/

var Player = function(items) {
	this.key = items.key || this.key;
	this.wrapper = items.wrapper || this.wrapper;
	this.track = items.track || this.track;
	this.timer = items.timer || this.timer;
	this.duration = items.duration || this.duration;
	this.playBtn = items.playBtn || this.playBtn;
	this.pauseBtn = items.pauseBtn || this.pauseBtn;
	this.progress = items.progress || this.progress;
	this.preloadProgress = items.preloadProgress || this.preloadProgress;
	this.progressBar = items.progressBar || this.progressBar;

	this.init();
};

Player.prototype = {
	key: 0,
	sound: null,
	wrapper: ".audio-wrapper",
	track: ".track",
	timer: ".timer",
	duration: ".duration",
	playBtn: ".playBtn",
	pauseBtn: ".pauseBtn",
	progress: ".progress",
	preloadProgress: ".preloadProgress",
	progressBar: ".progressBar",

	init: function() {
		let self = this;

		if(typeof(self.wrapper) == "string") {
			self.wrapper = document.querySelector(self.wrapper);
		}

		self.track = self.wrapper.querySelector(self.track);
		self.timer = self.wrapper.querySelector(self.timer);
		self.duration = self.wrapper.querySelector(self.duration);
		self.playBtn = self.wrapper.querySelector(self.playBtn);
		self.pauseBtn = self.wrapper.querySelector(self.pauseBtn);
		self.progress = self.wrapper.querySelector(self.progress);
		self.preloadProgress = self.wrapper.querySelector(self.preloadProgress);
		self.progressBar = self.wrapper.querySelector(self.progressBar);

		// Bind our player controls.
		if (self.playBtn) {
			self.playBtn.addEventListener('click', function() {
				self.play();
			});
		}

		if (self.pauseBtn) {
			self.pauseBtn.addEventListener('click', function() {
				self.pause();
			});
		}

		if (self.progress) {
			self.progress.addEventListener('input', function(event) {
			    var progress = event.target.value;
			    self.seek(progress);
			});
		}
	},

	/**
	* Play a song in the playlist.
	* @param  {Number} index Index of the song in the playlist (leave empty to play the first or current).
	*/
	play: function() {
		let self = this;
		// let sound;

		document.querySelectorAll(".audio-wrapper").forEach(function(wrapper, key) {
			if(player[key] != self.key && player[key].sound) {
				player[key].pause();
			}
		});

		// If we already loaded this track, use the current one.
		// Otherwise, setup and load a new Howl.

		// console.log(progress);
		if (! self.sound) {
			self.sound = new Howl({
				src: self.progress.dataset.previewurl,
				html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
				preload: true,
				onplay: function() {
					// Display the duration.
					self.duration.innerHTML = self.formatTime(Math.round(self.sound.duration()));

					self.track.classList.add('up');
					// Start upating the progress of the track.
					requestAnimationFrame(self.step.bind(self));
				},
				onload: function() {
                    // Audio loaded successfully
                    // self.preloadProgress.style.width = '100%'; // Set the progress to 100% when loaded
                },
				onloaderror: function(error) {
                    console.error('Failed to load audio:', error);
                    // Handle error (e.g., display an error message)
                },
				onseek: function() {
		        	// Start updating the progress of the track.
		        	requestAnimationFrame(self.step.bind(self));
		        }
			});
		}

		// Begin playing the sound.
		self.sound.play();

		// Show the pause button.
		if (self.sound.state() === 'loaded') {
			self.playBtn.style.display = 'none';
			self.pauseBtn.style.display = 'block';
			self.track.classList.add('up');
		} else {
			self.playBtn.style.display = 'none';
			self.pauseBtn.style.display = 'block';
			self.track.classList.remove('up');
		}
	},

	// Pause the currently playing track.
	pause: function() {
		// Puase the sound.
		this.sound.pause();

		// Show the play button.
		this.playBtn.style.display = 'block';
		this.pauseBtn.style.display = 'none';
		this.track.classList.remove('up');
	},

	/**
	* Seek to a new position in the currently playing track.
	* @param  {Number} per Percentage through the song to skip.
	*/
	seek: function(per) {
		// Get the Howl we want to manipulate.
		// let sound = self.playlist[self.index].howl;

		// Convert the percent into a seek position.  (This will use whn range slider wil change its positions)
		if (this.sound.playing()) {
			this.sound.seek(this.sound.duration() * per);
		}
	},

	// The step called within requestAnimationFrame to update the playback position.
	step: function() {
		// Determine our current seek position.
		let seek = this.sound.seek() || 0;
		this.timer.innerHTML = this.formatTime(Math.round(seek));

	    // Update the range input value.
		let percentage = ((seek / this.sound.duration()) * 100) || 0;
	    let rangeValue = (percentage / 100) * this.progress.max;
	    this.progress.value = rangeValue;
	    // this.progressBar.style.width = percentage + '%'; // For progress bar increase width by audio playing

		// If the sound is still playing, continue stepping.
		if (this.sound.playing()) {
			requestAnimationFrame(this.step.bind(this));
		}
	},

	/**
	* Format the time from seconds to M:SS.
	* @param  {Number} secs Seconds to format.
	* @return {String}      Formatted time.
	*/
	formatTime: function(secs) {
		let minutes = Math.floor(secs / 60) || 0;
		let seconds = (secs - minutes * 60) || 0;

		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	},
};

let player = [];
document.querySelectorAll(".audio-wrapper").forEach(function(wrapper, key){
	// Setup our new audio player class and pass it the playlist.
	player[key] = new Player({
		key: key,
		wrapper: wrapper,
		// track: ".track",
		// timer: ".timer",
		// duration: ".duration",
		// playBtn: ".playBtn",
		// pauseBtn: ".pauseBtn",
		// progress: ".progress",
		// preloadProgress: ".preloadProgress",
		// progressBar: ".progressBar",
	});
});
